import { bookingService } from "../../helpers/bookingService";

export const state = {
  getAllUpcomingBooking: [],
  upComingBookingCount: "",
  getAllCompletedBooking: [],
  completedBookingCount: "",
  getAllCancelBooking: [],
  getAllBookingInfo: [],
  getAllMyBooking: [],
  getAllMyBookingCount: "",
  cancelBookingCount: "",
  pagination: {},
  loading: true,
};

export const mutations = {
  getAllUpcomingBooking(state, payload) {
    state.getAllUpcomingBooking = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.upComingBookingCount = payload.result.total;
  },
  getAllCompletedBooking(state, payload) {
    state.getAllCompletedBooking = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.completedBookingCount = payload.result.total;
  },
  getAllCancelBooking(state, payload) {
    state.getAllCancelBooking = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.cancelBookingCount = payload.result.total;
  },
  getAllBookingInfo(state, payload) {
    state.getAllBookingInfo = payload.result;
    state.loading = false;
  },
  getAllMyBooking(state, payload) {
    state.getAllMyBooking = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.getAllMyBookingCount = payload.result.total;
  },
  getUpcomingListRequest(state) {
    state.loading = true;
  },
  getCompletedListRequest(state) {
    state.loading = true;
  },
  getCancelListRequest(state) {
    state.loading = true;
  },
  getMyBookingListRequest(state) {
    state.loading = true;
  },
  getUpcomingBooking(state, payload) {
    state.user = payload.result;
  },
  getCompletedBooking(state, payload) {
    state.user = payload.result;
  },
  getCancelBooking(state, payload) {
    state.user = payload.result;
  },
  getUpcomingBookingListFailure(state) {
    state.loading = false;
  },
  getCompletedBookingListFailure(state) {
    state.loading = false;
  },
  getCancelBookingListFailure(state) {
    state.loading = false;
  },
};

export const actions = {
  async getUpcomingBookingOnOff({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUpcomingListRequest");
    await bookingService.getUpcomingBookingOnOff(data).then(
      (response) => {
        console.log(response);
        if (response.status == 200) {
          dispatch("getUpcomingBooking");
        }
      },
      (error) => {
        commit("getUpcomingBookingListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getBooking({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getUpcomingListRequest");
    await bookingService.getBooking(data).then(
      (response) => {
        commit("getAllBookingInfo", response.data);
      },
      (error) => {
        commit("getCompletedPaymentListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getUpcomingBooking({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUpcomingListRequest");
    await bookingService.getUpcomingBooking(data).then(
      (response) => {
        commit("getAllUpcomingBooking", response.data);
      },
      (error) => {
        commit("getUpcomingBookingListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getCompletedBooking({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getCompletedListRequest");
    await bookingService.getCompletedBooking(data).then(
      (response) => {
        commit("getAllCompletedBooking", response.data);
      },
      (error) => {
        commit("getUpcomingBookingListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getCancelBooking({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getCancelListRequest");
    await bookingService.getCancelBooking(data).then(
      (response) => {
        commit("getAllCancelBooking", response.data);
      },
      (error) => {
        commit("getCancelBookingListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getMyBooking({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getMyBookingListRequest");
    await bookingService.getMyBooking(data).then(
      (response) => {
        commit("getAllMyBooking", response.data);
      },
      (error) => {
        commit("getCancelBookingListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};
export const getters = {
  loading: (state) => state.loading,
  getAllUpcomingBooking: (state) => state.getAllUpcomingBooking,
  upComingBookingCount: (state) => state.upComingBookingCount,
  upComingBookingData: (state) => state.getUpcomingBooking,
  getAllCompletedBooking: (state) => state.getAllCompletedBooking,
  completedBookingCount: (state) => state.completedBookingCount,
  getAllMyBookingCount: (state) => state.getAllMyBookingCount,
  getAllCancelBooking: (state) => state.getAllCancelBooking,
  getAllMyBooking: (state) => state.getAllMyBooking,
  cancelBookingCount: (state) => state.cancelBookingCount,
  pagination: (state) => state.pagination,
  getAllBookingInfo: (state) => state.getAllBookingInfo,
};
